const react = require('./src/muster-react/src');
module.exports = react;
